import config from 'config';
import store from '../store';
import Utils from '../utils/utils';
import * as types from '../actions/game-actions';
import * as userTypes from '../actions/user-actions';
import * as errorTypes from '../actions/error-actions';
import * as ticketTypes from '../actions/ticket-actions';

import UserApi from './user-api';
import LoginApi from './login-api';
import CrossSellingApi from './crossSelling-api';

import dbInstance from './dbInstace';

class GameApi {

	/**
	 * Count tickets
	 */
	static countTickets(game) {
		//let weeklyCount = (game.weeklyTickets) ? game.weeklyTickets.length : 0;
		//let trimestrialCount = (game.trimestrialTickets) ? game.trimestrialTickets.length : 0;
		//return weeklyCount + trimestrialCount;
		try{
			return game.monthlyTickets.length
		}catch(e){
			return 0
		}
	}

	/**
	 * Reset game
	 */
	static resetGame() {
		store.dispatch({
			type: types.RESET_GAME
		});

		return Promise.resolve({});
	}

	/**
	 * Get game object
	 */
	static getGame(game) {
		if (!game) return Promise.reject({});

		return this.getCrossSelling(game);
	}

	/**
	 * Gets crossSelling data by idFonograma, idArtist or idAlbum
	 * @param game
	 * @returns {Promise.<TResult>}
	 */
	static getCrossSelling(game){
		return CrossSellingApi.getCMCrossSelling(game).then(response => {
			game.crossSelling = {claroMusica: null, rbt: null};

			if (response){
				game.crossSelling = {claroMusica: {}, rbt: {}};
				game.crossSelling.claroMusica = response;

				if (game.currentQuestion.idPhonogram && response.text){
					game.crossSelling.rbt.link = config.application.rbtPath.phonogram + game.currentQuestion.idPhonogram;
					game.crossSelling.rbt.text = response.text;
				} else {
					game.crossSelling.rbt = null;
				}
			}

			store.dispatch({
				type: types.GET_GAME,
				game: game,
			});

			return game;
		}).catch(err => {
			console.info(err);

			return err;
		});
	}

	/**
	 * Shows review after get answer response
	 */
	static answerQuestion(params) {

		let user = params.user;
		let msisdn = user.msisdn;
		let questionId = (user.game.currentQuestion) ? user.game.currentQuestion.id.counter : null;
		if (msisdn) msisdn = Utils.insertMsisdnPrefix(msisdn);

		params = {params: {
			msisdn,
			questionId,
			action: config.constants.API.actions['answer_' + params.answerCode]
		}};

		return dbInstance.get(config.core.API.routes.action, params).then(response => {
			console.debug(response);

			if (response.error)	return response;
			
			let isCorrect = (response.game.lastAnswered.answer === response.game.lastAnswered.correctAnswerWebNum);
			Utils.gaSend('Game', 'Respostas', (isCorrect) ? 'Certas' : 'Erradas');


			let wonNewTicket = (GameApi.countTickets(response.game) > GameApi.countTickets(user.game));

			store.dispatch({
				type: types.ANSWER_REVISION,
				isCorrect
			});
			store.dispatch({
				type: userTypes.GET_USER_SUCCESS,
				user: response,
				wonNewTicket
			});
			if (wonNewTicket){
				store.dispatch({
					type: ticketTypes.UPDATE_TICKET_LIST,
					game: response.game
				});
			}

			return response
		}).catch(err => {
			return {error: true};
		});
	}

	/**
	 * Buys extra round of questions
	 */
	static buyExtraRound(msisdn) {

		if (msisdn) msisdn = Utils.insertMsisdnPrefix(msisdn);

		let params = {params: {
			msisdn,
			action: config.constants.API.actions.extra_round
		}};

		return dbInstance.get(config.core.API.routes.action, params).then(response => {
			console.debug(response);

			Utils.gaSend('Rodada Extra', 'Compra', 'Sucesso');

			this.getCrossSelling(response.game);
			store.dispatch({
				type: userTypes.GET_USER_SUCCESS,
				user: response
			});

			return response
		}).catch(err => {
			console.info(err);

			Utils.gaSend('Rodada Extra', 'Compra', 'Erro');

			return err;
		});
	}

	/**
	 * Start daily
	 */
	static startDaily(msisdn) {

		let questionId = null;
		if (msisdn) msisdn = Utils.insertMsisdnPrefix(msisdn);

		let params = {params: {
			msisdn,
			questionId,
			action: config.constants.API.actions.start_daily
		}};

		return dbInstance.get(config.core.API.routes.action, params).then(response => {
			console.debug(response);

			if (response.msisdn){
				response.msisdn = Utils.removeMsisdnPrefix(response.msisdn);
			}

			store.dispatch({
				type: userTypes.GET_USER_SUCCESS,
				user: response
			});
			store.dispatch({
				type: ticketTypes.UPDATE_TICKET_LIST,
				game: response.game
			});

			return response
		}).catch(err => {
			console.info(err);

			return err;
		});
	}
}

export default GameApi;


// WEBPACK FOOTER //
// ./src/api/game-api.js